<template>
  <section class="add-test-dialog" v-loading="loading">
    <div class="add-tests-navbar">
      <el-row type="flex" align="middle">
        <el-col :span="4">
          <div class="title">
            <div class="icon-block">
              <div class="icon-text">
                <h3>Select Tests</h3>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="search-tests-block">
            <div class="selected-test mr-15">
              <el-select
                v-model="selectedTestPanel"
                @change="getAllTests"
                placeholder="Select Test Panel"
                :disabled="!isNew"
                filterable
                clearable
              >
                <el-option
                  v-for="(caseType, index) of getCaseTypes"
                  :key="index"
                  :value="caseType.value"
                  :label="caseType.label"
                  :disabled="checkAlreadyExist(caseType.value)"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="search-tests-block">
            <div class="search-input">
              <el-form>
                <el-input
                  placeholder="search"
                  suffix-icon="el-icon-search"
                  clearable
                  v-model="searchString"
                ></el-input>
              </el-form>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="close-popup">
            <el-button size="medium" class="" type="info" @click="closeDialog">
              <img src="@/assets/images/close-icon.svg" alt="icon"
            /></el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="select-tests-popup" v-if="selectedTestPanel">
      <el-row>
        <el-col :span="14">
          <div class="selection-tests-group">
            <div class="test-panels">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                  v-for="(caseType, index) of selectedCaseTypes"
                  :key="index"
                  :label="caseType.label"
                  :name="caseType.label"
                >
                  <div>
                    <ul>
                      <li
                        class="each-test"
                        v-for="(category, index) of getCaseCategoryData(
                          caseType.value
                        )"
                        :key="index"
                      >
                        <el-collapse v-model="activeNameCollapse" accordion>
                          <el-collapse-item :name="index">
                            <template #title>{{ category.category }}</template>
                            <el-checkbox
                              :model-value="
                                isCheckAll(
                                  category.case_type_code,
                                  category.category_code
                                )
                              "
                              @change="
                                checkAll(
                                  $event,
                                  category.case_type_code,
                                  category.category_code
                                )
                              "
                              >All</el-checkbox
                            >
                            <el-checkbox-group v-model="testsData">
                              <div
                                v-for="(
                                  item, index
                                ) of getCategoryWiseTestsData(
                                  category.case_type_code,
                                  category.category_code
                                )"
                                :key="index"
                              >
                                <div class="each-check-box">
                                  <el-checkbox
                                    :label="item._id"
                                    :value="item"
                                    >{{ item.name }}</el-checkbox
                                  >
                                </div>
                              </div>
                            </el-checkbox-group>
                          </el-collapse-item>
                        </el-collapse>
                      </li>
                    </ul>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="current-selected-tests">
            <div class="c_header">
              <h4>CURRENT SELECTION</h4>
            </div>
            <div class="c_body">
              <div class="inside-scroll">
                <div
                  class="each-item"
                  v-for="(categoryData, cindex) of getCategoriesOfSelectedTests"
                  :key="cindex"
                >
                  <h4 class="category-name">{{ categoryData.category }}</h4>
                  <div class="selected-tests-list-group">
                    <ul class="selected-tests-list">
                      <li
                        v-for="(test, index) of getCategoryWiseSelectedTests(
                          categoryData.category_code
                        )"
                        :key="index"
                      >
                        <span class="test-name">
                          {{ test.name }}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="add-test-button">
                <el-button @click="addTests"> Add Test </el-button>
              </div>
              <div
                v-if="getPanelAddErrors && getPanelAddErrors.tests"
                class="center-error-message"
              >
                <p class="err mb-05">
                  {{ getPanelAddErrors.tests }}
                </p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <div class="add-test-button-group">
        <el-row>
          <el-col :span="24">
            <p
              class="error mb-05"
              v-if="getPanelAddErrors && getPanelAddErrors.critical_error"
            >
              {{ getPanelAddErrors.critical_error }}
            </p>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="no-test-content" v-if="!selectedTestPanel">
      <img src="@/assets/images/icons/select-test-panel.svg" alt="" />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import AppHelper from "@/mixins/AppHelper";
export default {
  props: ["selectedTestIds", "isNew", "panelValue", "labId", "existedPanels"],
  mixins: [AppHelper],
  data() {
    return {
      activeNameCollapse: "",
      search_case_types: caseConstants.CASE_TYPES_DATA,

      activeName: "first",
      dialogVisible: false,
      checked: false,
      testsData: [],
      selectedCases: false,
      searchString: null,
      loading: false,
      selectedTestPanel: "",
      selectedPanel: "",
      selectedPanelTests: [],
      selectedData: [],
      status: ["ACTIVE", "INACTIVE"],
    };
  },
  computed: {
    ...mapGetters("testpanel", [
      "getAllTestPanels",
      "getTestPanelsByLabId",
      "getPanelAddErrors",
      "getPanelAddStatus",
    ]),
    ...mapGetters("labs", ["getTestPanels"]),
    allCaseTypes() {
      let panels = [...this.search_case_types];
      return panels.sort((a, b) => a.value.localeCompare(b.value));
    },

    getAllLabTests() {
      return this.selectedPanelTests;
    },

    selectedCaseTypes() {
      return this.search_case_types.filter(
        (e) => e.value == this.selectedTestPanel
      );
    },
    getTestsInformationObject() {
      const obj = {};
      if (this.getAllLabTests) {
        this.getAllLabTests.forEach((el) => {
          obj[el._id] = el;
        });
      }
      return obj;
    },
    selectedTestsDetails() {
      const data = [];
      if (this.testsData) {
        this.testsData.forEach((el) => {
          if (el && this.getTestsInformationObject[el])
            data.push(this.getTestsInformationObject[el]);
        });
      }

      return data;
    },
    getCaseTypes() {
      return this.allCaseTypes;
    },
    selectedTestsDetailsWithoutDuplicates() {
      let allData = [...this.selectedTestsDetails];
      return this.removeDuplicatesByProperty(allData, "_id");
    },
    getCategoriesOfSelectedTests() {
      if (
        !this.selectedTestsDetailsWithoutDuplicates ||
        !this.selectedTestsDetailsWithoutDuplicates.length
      ) {
        return [];
      }
      let tests = [...this.selectedTestsDetailsWithoutDuplicates];
      let selectedCategoriesKey = [];
      let selectedCategories = [];

      tests.forEach((test) => {
        if (selectedCategoriesKey.indexOf(test.category_code) == -1) {
          selectedCategoriesKey.push(test.category_code);
          selectedCategories.push({
            category_code: test.category_code,
            category: test.category,
          });
        }
      });
      return selectedCategories;
    },
    getCategoryWiseSelectedTests() {
      return (category) => {
        let tests = [...this.selectedTestsDetailsWithoutDuplicates];
        return tests.filter((test) => test.category_code == category);
      };
    },
  },
  methods: {
    getCategoryWiseTestsData(caseType, category) {
      let data = [];
      if (this.searchString) {
        data = this.getAllLabTests.filter(
          (el) =>
            el.case_type_code === caseType &&
            el.category_code === category &&
            (el.name.toLowerCase().includes(this.searchString.toLowerCase()) ||
              el.category
                .toLowerCase()
                .includes(this.searchString.toLowerCase()))
        );
      } else {
        data = this.getAllLabTests.filter(
          (el) =>
            el.case_type_code === caseType && el.category_code === category
        );
      }
      return this.sortByKey(data, "test_name");
    },
    getSelectedDataObject() {
      this.selectedPanelTests.forEach((test) => {
        if (this.testsData.indexOf(test._id) != -1) {
          this.selectedData.push(test);
        }
      });
    },
    getCaseCategoryData(caseType) {
      const data = this.getAllLabTests.filter(
        (el) =>
          el.case_type_code === caseType &&
          (!this.searchString ||
            el.name.toLowerCase().includes(this.searchString.toLowerCase()) ||
            el.category.toLowerCase().includes(this.searchString.toLowerCase()))
      );
      let flags = [],
        output = [],
        outputWithFullDetails = [],
        l = data.length,
        i;
      for (i = 0; i < l; i++) {
        if (flags[data[i].category_code]) continue;
        flags[data[i].category_code] = true;
        output.push(data[i].category_code);
        outputWithFullDetails.push(data[i]);
      }
      return outputWithFullDetails;
    },
    async addTests() {
      try {
        this.getSelectedDataObject();
        let params = {
          lab: this.labId,
          name: this.selectedPanel.name,
          code: this.selectedPanel.code,
          case_type_letter_code: this.selectedPanel.case_type_letter_code,
          tests: this.selectedData,
        };

        await this.$store.dispatch("testpanel/addTestPanels", params);
        if (this.getPanelAddStatus) {
          if (this.isNew) {
            this.$notify({
              title: "Success",
              message: "Panel added successfully",
              type: "success",
            });
          } else {
            this.$notify({
              title: "Success",
              message: "Panel updated successfully",
              type: "success",
            });
          }
          this.$emit("addedPanel", this.selectedPanel.code);
          this.selectedData = [];
        } else if (!this.getPanelAddErrors) {
          this.$notify.error({
            title: "Error",
            message:
              this.getPanelAddErrors && this.getPanelAddErrors.critical_error
                ? this.getPanelAddErrors.critical_error
                : "Error in adding test panel",
          });
        }
      } catch (err) {
        console.log(err);
      }
    },

    handleClick() {},
    closeDialog() {
      this.$emit("addTestsData", this.selectedTestsDetails);
    },
    removeSelectionFromTests(deletingTest) {
      let allTests = this.selectedTestsDetails;
      let deletingIds = allTests
        .filter((e) => e.name == deletingTest.name)
        .map((e) => e._id);
      this.testsData = this.testsData.filter(
        (testId) => !deletingIds.includes(testId)
      );
    },
    checkAll(data, caseType, category) {
      let selectedTestData = this.getCategoryWiseTestsData(
        caseType,
        category
      ).map((item) => item._id);
      if (data) {
        for (let i = 0; i < selectedTestData.length; i++) {
          if (this.testsData.indexOf(selectedTestData[i]) == -1) {
            this.testsData.push(selectedTestData[i]);
          }
        }
      } else {
        for (let i = 0; i < selectedTestData.length; i++) {
          let index = this.testsData.indexOf(selectedTestData[i]);
          if (index > -1) {
            this.testsData.splice(index, 1);
          }
        }
      }
    },

    isCheckAll(caseType, category) {
      let selectedTestData = this.getCategoryWiseTestsData(
        caseType,
        category
      ).map((item) => item._id);

      return selectedTestData.every((item) => {
        return this.testsData.indexOf(item) !== -1;
      });
    },
    async getAllTests() {
      await this.$store.dispatch("testpanel/fetchTestPanels", {
        code: this.selectedTestPanel,
        panel_type: this.selectedTestPanel,
        details: true,
        status: this.status,
      });
      this.selectedPanel =
        this.getAllTestPanels.data && this.getAllTestPanels.data.length
          ? this.getAllTestPanels.data[0]
          : {};
      this.selectedPanelTests =
        this.selectedPanel && this.selectedPanel.tests
          ? this.selectedPanel.tests
          : [];

      if (
        this.selectedCaseTypes &&
        this.selectedCaseTypes.length &&
        this.selectedCaseTypes[0]
      ) {
        this.activeName = this.selectedCaseTypes[0].label;
      }
    },

    checkAlreadyExist(value) {
      if (this.existedPanels && this.existedPanels.length) {
        return this.existedPanels.find((x) => x.code == value) ? true : false;
      }
      return false;
    },
  },
  watch: {
    selectedTestIds() {
      this.testsData = this.selectedTestIds;
    },
  },
  async mounted() {
    this.loading = true;
    this.$store.dispatch("testpanel/fetchDefaultTestPanels", { get_all: true });
    if (!this.isNew) {
      this.selectedTestPanel = this.panelValue;
      this.getAllTests();
      this.testsData = JSON.parse(JSON.stringify(this.selectedTestIds));
    } else {
      this.testsData = [];
    }

    this.loading = false;
  },
};
</script>

<style lang="scss">
@mixin search-bar {
  border-radius: 5px;
  height: 30px;
  border: none;
}
.add-test-dialog {
  border-radius: 10px 10px 0 0;
  .add-tests-navbar {
    align-items: center;
    background: #bf1b39;
    border-radius: 5px 6px 0px 0px;
    padding: 5px 15px;
    color: #fff;

    .navbar-search {
      width: 80%;
      margin: 0 auto;
      position: relative;
    }
    .form-group {
      display: flex;
      justify-content: center;
      span {
        right: 30px;
      }

      .search-icon {
        position: absolute;
        top: 4px;
        width: 22px;
        height: 22px;
        right: 5px;
      }
      .el-input__inner {
        font-weight: 500;
        color: #333;
      }
    }
    .close-popup {
      display: flex;
      justify-content: flex-end;
      .el-button {
        background: none;
        border: none;
      }
    }
    .err {
      color: white !important;
    }
  }
  .test-popup {
    h3 {
      color: #ffffff;
      margin: 0;
      padding: 0 25px 0 10px;
    }
  }
  .el-input--suffix .el-input__inner {
    @include search-bar;
  }
  .selection-tests-group {
    .test-panels {
      .el-tabs {
        .el-tabs__item.is-active {
          color: #0a5da6;
        }
        .el-tabs__active-bar {
          background-color: #0a5da6;
          border-radius: 25px;

          height: 1.5px;
        }
        .el-tabs__nav-wrap {
          padding: 0 20px;
        }
        .el-tabs__nav-wrap::after {
          background-color: #e7e7f7;
          height: 1px;
        }
        .el-tabs__content {
          height: 500px;
          overflow: auto;
          margin-right: 5px;
          padding: 0 10px 0 15px;
        }

        &::-webkit-scrollbar {
          width: 3px;
        }

        &::-webkit-scrollbar-thumb {
          background: #ccc;
        }

        &::-webkit-scrollbar-thumb:hover {
          background: #0a5da6;
        }
      }
      //
      .all-tests {
        padding-bottom: 15px;
        .each-test {
          &:not(:last-child) {
            margin-bottom: 10px;
          }
          .el-collapse {
            --el-collapse-border-color: none;
            .el-collapse-item__header {
              border: none;
              background: #f4f4f4;
              border-radius: 6px;
              color: #4f4f4f;
              font-weight: 500;
              padding: 0 10px;
              height: auto;
              height: 30px;
              .all-orders-img {
                width: 10px;
                padding: 10px 5px 0 5px;
                img {
                  width: 10px;
                  height: 10px;
                }
              }
            }
            .el-collapse-item__wrap {
              border: none;
            }
            .el-collapse-item__header.is-active {
              border: none;
            }
            .el-collapse-item__content {
              --el-collapse-border-color: none;
              padding: 10px 5px 15px 5px;
              overflow: auto;
            }
          }
        }
      }
      .test-panels-list {
        display: flex;
        width: 100%;
        .test-panels-list-left {
          width: 50%;

          ul {
            display: flex;
            li {
              color: #4f4f4f;
              font-weight: 500;
              font-size: 15px;
            }
          }
        }
        .test-panels-list-right {
          width: 48%;
          display: flex;
          justify-content: right;
          .el-button {
            padding: 0;
            border: none;
            color: #219653;
            background: transparent;
            &:active {
              color: #219653;
              background: transparent;
            }
          }
        }
      }
      .tests-list {
        ul {
          display: flex;
          li {
            padding: 10px 5px;
            .el-checkbox:last-of-type {
              border: none;
              background: #ffffff;
              padding: 0 7px;
            }
          }
        }
      }

      .text-check-box {
        display: flex;
      }

      .el-checkbox {
        height: 25px;
        font-size: 13px;
      }

      .el-checkbox__input {
        background: #ffffff;
        border: 1.27979px solid #9c9c9c;
        box-sizing: border-box;
        border-radius: 3.83936px;
      }
      .el-checkbox__inner {
        border-radius: 2.55957px;
        margin: 1px;
        width: 13px;
        height: 13px;
        border: none;
      }
      .el-checkbox__inner::after {
        content: "";
        border: 1.6px solid var(--el-checkbox-checked-icon-color);
        border-left: 0;
        border-top: 0;
        height: 6px;
        left: 4px;
        position: absolute;
        top: 1px;
        transform: rotate(45deg) scaleY(0);
        width: 3px;
        transition: transform 0.15s ease-in 50ms;
        transform-origin: center;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner::after {
        transform: rotate(45deg) scaleY(1);
      }
      .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        & > div {
          width: 33.33%;
          padding: 3px 0;
        }

        .each-checkbox-test {
          width: 25%;
        }
        .each-check-box {
          margin-right: 10px;
        }
      }

      .el-collapse-item__arrow {
        color: #4f4f4f;
        font-size: 21px;
        position: absolute;
        right: 20px;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background: #0a5da6;
        border: 0.5px solid #0a5da6;
      }
      .el-checkbox__label {
        font-size: 13px;
        white-space: pre-wrap;
      }
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #0a5da6;
      }
    }
  }
  .no-test-content {
    padding: 6rem;
    text-align: center;
  }
}
</style>
